import {
  useRouteError,
  isRouteErrorResponse,
  useRevalidator,
} from 'react-router'
import { ErrorFallbackProps } from './ErrorFallbackBase'
import { ComponentType } from 'react'

export const RouteErrorBoundary = ({
  FallbackComponent,
}: {
  FallbackComponent: ComponentType<ErrorFallbackProps>
}) => {
  const error = useRouteError()
  const { revalidate } = useRevalidator()

  // Convert route error to Error object
  let errorObject: Error

  if (isRouteErrorResponse(error)) {
    // This is a Response error (like 404, 500, etc.)
    errorObject = new Error(
      error.statusText ||
        `${error.status}: ${
          typeof error.data === 'string'
            ? error.data
            : error.data
              ? JSON.stringify(error.data)
              : 'Request failed'
        }`
    )
  } else if (error instanceof Error) {
    errorObject = error
  } else if (typeof error === 'string') {
    errorObject = new Error(error)
  } else {
    errorObject = new Error('An unexpected error occurred')
  }

  // Render the custom fallback component
  return (
    <FallbackComponent error={errorObject} resetErrorBoundary={revalidate} />
  )
}
